import { api } from '@smena/ui';

export interface SystemInfo {
  version: string;
  nodeVersion: string;
  uptimeSec: number;
  startedAt: string;
  db: { ok: boolean; latencyMs: number | null; error: string | null };
  migrations: { applied: number; last: string[] };
  llm: { baseUrlHost: string | null; model: string | null; keyMasked: string | null };
  embed: { baseUrlHost: string | null; model: string | null };
  env: Record<string, string>;
}

export function fetchSystem(): Promise<SystemInfo> {
  return api<SystemInfo>('/api/admin/system');
}
